import { render, staticRenderFns } from "./BuyBusinessDetails.vue?vue&type=template&id=6f222450&scoped=true&"
import script from "./BuyBusinessDetails.vue?vue&type=script&lang=js&"
export * from "./BuyBusinessDetails.vue?vue&type=script&lang=js&"
import style0 from "./BuyBusinessDetails.vue?vue&type=style&index=0&id=6f222450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f222450",
  null
  
)

export default component.exports